import React from 'react';
import { ButtonProps } from '@mui/material';
import { StyledButton, StyledOutlinedButton } from './CustomButton.styled';

interface CustomButtonProps extends ButtonProps {
  label?: string | null;
  sizing?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  bgcolor?: 'primary' | 'error' | 'warning' | 'success' | 'transparent';
}

interface OutlineButtonProps extends CustomButtonProps {
  outlineColor?: 'primary' | 'error' | 'warning' | 'success';
}

export const CustomButton = (props: CustomButtonProps) => {
  const {
    sizing,
    bgcolor,
    children,
    ...rest
  } = props;
  return (
    <StyledButton
      sizing={sizing ? sizing : 'md'}
      bgcolor={bgcolor ? bgcolor : 'primary'}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export const CustomOutlinedButton = (props: OutlineButtonProps) => {
  const {
    sizing,
    outlineColor,
    children,
    ...rest
  } = props;
  return (
    <StyledOutlinedButton
      sizing={sizing ? sizing : 'md'}
      outlineColor={outlineColor ? outlineColor : 'primary'}
      disableRipple
      {...rest}
    >
      {children}
    </StyledOutlinedButton>
  );
};
